import { Icon as BlueIcon } from '@blueprintjs/core';

import { UpdateStatusPriority } from '@models/UpdateStatus.model';

import { getUpdateFlagColor } from '@utils/index';

import { FlagContainer, FlagLabel, Row } from './Details.styles';
import {
  IDetailsFormData,
  IDetails,
  IDetailsDisabledMap,
  UpdateNeeded,
} from './types';

export const options = [
  {
    value: 'urgent',
    label: (
      <Row>
        <FlagContainer>
          <BlueIcon
            icon="flag"
            color={getUpdateFlagColor(UpdateStatusPriority.URGENT)}
          />
        </FlagContainer>
        <FlagLabel>Urgent</FlagLabel>
      </Row>
    ),
  },
  {
    value: 'important',
    label: (
      <Row>
        <FlagContainer>
          <BlueIcon
            icon="flag"
            color={getUpdateFlagColor(UpdateStatusPriority.IMPORTANT)}
          />
        </FlagContainer>
        <FlagLabel>Important</FlagLabel>
      </Row>
    ),
  },
  {
    value: 'non-critical',
    label: (
      <Row>
        <FlagContainer>
          <BlueIcon
            icon="flag"
            color={getUpdateFlagColor(UpdateStatusPriority.NONCRITICAL)}
          />
        </FlagContainer>
        <FlagLabel>Non-critical</FlagLabel>
      </Row>
    ),
  },
  {
    value: 'uncertain',
    label: (
      <Row>
        <FlagContainer>
          <BlueIcon
            icon="flag"
            color={getUpdateFlagColor(UpdateStatusPriority.UNCERTAIN)}
          />
        </FlagContainer>
        <FlagLabel>Uncertain</FlagLabel>
      </Row>
    ),
  },
];

export function createDefaultDetails(
  update?: UpdateNeeded | undefined,
): IDetailsFormData {
  const details: IDetailsFormData = {
    title: update?.subject ?? '',
    description: update?.description ?? '',
    priority: null,
    date: update?.date ?? null,
    originalMessage: update?.message ?? '',
  };

  return details;
}
export function getEnabledMap(mode: IDetails['mode']): IDetailsDisabledMap {
  const map: IDetailsDisabledMap = new Map();

  const enabledInsights = [
    'title',
    'description',
    'date',
    'originalMessage',
  ] as const;

  const enabledBeamOn = [...enabledInsights, 'assignee', 'priority'] as const;
  if (mode === 'editing.insights') {
    enabledInsights.forEach(value => map.set(value, true));
    return map;
  }

  enabledBeamOn.forEach(value => map.set(value, true));
  return map;
}
export function getDateLabel(mode: IDetails['mode']) {
  if (mode === 'editing.insights') return 'Sent Date';
  return 'Due Date';
}
